import React from 'react';

import I18n from '@wetransfer/transfer/modules/i18n';
import { IconAdd } from '@wetransfer/transfer/spaces-bundle/components/Icons/Icons';
import { Spinner } from '@wetransfer/transfer/spaces-bundle/components/Spinner/Spinner';

import '../TeamItem/TeamItem.scss';

export interface Props {
  userName: string;
  isCreatingTeam: boolean;
}

export const CreateTeamAccountItem: React.FC<Props> = ({
  userName,
  isCreatingTeam,
}) => {
  return (
    <div
      className="TeamItem TeamItem--inactive"
      data-testid="create-team-account-item"
    >
      <div className="TeamItem__avatar TeamItem__add">
        {!isCreatingTeam ? <IconAdd color="grey300" /> : <Spinner />}
      </div>
      <div className="TeamItem__body">
        <p className="TeamItem__title">{userName}</p>
        <div className="TeamItem__metadata">
          <span>{I18n.t('navigation.switcher.just_you')}</span>
          <span>{I18n.t('navigation.switcher.create_free_account')}</span>
        </div>
      </div>
    </div>
  );
};
